import { kEmployeeSupervisorID } from "@coreapp/constants";
import { SynthesizePositions } from "@coreapp/utils/SynthesizePositions";

export const PLAN_GENERAL_TEST_PREFIX = "plan-settings-general-";

export const getRequiredFieldNames = (
  requiredFieldIds: string[],
  allFieldNames: string[],
  chartMetadata: any
): string[] => {
  const mapping = chartMetadata?.fields ?? {};
  const isSynthPositions = SynthesizePositions(chartMetadata);
  const allFieldNamesSet = new Set(allFieldNames);
  const fieldNames = requiredFieldIds
    .filter(fieldId => (isSynthPositions ? true : fieldId !== kEmployeeSupervisorID))
    .map(fieldId => mapping[fieldId] ?? fieldId)
    .filter(fieldName => fieldName && allFieldNamesSet.has(fieldName));
  return fieldNames;
};

export const getAdditionalFieldNames = (
  requiredFieldNames: string[],
  allFieldNames: string[]
): string[] => {
  const requiredFieldNamesSet = new Set(requiredFieldNames);
  return allFieldNames.filter(fieldName => fieldName && !requiredFieldNamesSet.has(fieldName));
};
